import React from 'react';
import styles from '../AdminTrackVideos.module.css';
import {
  asActionsArray,
  DeleteIcon,
  displayText,
  EditIcon,
  getContentCoverUrl,
  getContentId,
} from './helpers';

function SectionBox({ title, children }) {
  return (
    <section className={styles['section-box']}>
      <p className={styles['section-title']}>{title}</p>
      {children}
    </section>
  );
}

const ContentCard = React.memo(function ContentCard({ item, onEdit, onDelete }) {
  const contentId = getContentId(item);
  const actions = asActionsArray(item?.actions);
  const coverUrl = getContentCoverUrl(item);
  const contentTitle = displayText(item?.title);

  return (
    <article className={styles['task-card']}>
      <div className={styles['task-head']}>
        <p className={styles['task-order']}>{contentTitle}</p>
        <div className={styles['task-actions']}>
          <button type="button" className={styles['icon-button']} onClick={() => onEdit(item)} title="Edit" aria-label="Edit">
            <EditIcon />
          </button>
          <button
            type="button"
            className={`${styles['icon-button']} ${styles['icon-danger']}`}
            onClick={() => onDelete(item)}
            title="Delete"
            aria-label="Delete"
          >
            <DeleteIcon />
          </button>
        </div>
      </div>

      <div className={styles['task-media']}>
        {coverUrl ? (
          <img className={styles['cover-image']} src={coverUrl} alt={contentTitle === '-' ? 'Quick Richuel cover' : `${contentTitle} cover`} />
        ) : (
          <div className={styles['video-empty']}>No cover image</div>
        )}
      </div>

      <SectionBox title="DESCRIPTION">
        <p className={styles['section-text']}>{displayText(item?.description)}</p>
      </SectionBox>

      <SectionBox title="ACTION ITEMS:">
        {actions.length === 0 ? (
          <p className={styles['section-text']}>-</p>
        ) : (
          <ul className={styles['actions-list']}>
            {actions.map((action, actionIndex) => (
              <li key={`${contentId}-action-${actionIndex}`}>{action}</li>
            ))}
          </ul>
        )}
      </SectionBox>
    </article>
  );
});

function ContentsGrid({ contents, onEdit, onDelete }) {
  return (
    <div className={styles['cards-grid']}>
      {contents.map((item, index) => {
        const contentId = getContentId(item);
        return (
          <ContentCard
            key={contentId || `${item?.category_id}-${item?.title}-${index}`}
            item={item}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        );
      })}
    </div>
  );
}

export default ContentsGrid;
